import { MediaFactory } from '../../commons';
export class PerkFactory {
    static create(props = {}) {
        const defaultProps = {
            id: 1,
            name: 'Perk',
            description: 'Perk description',
            icon: MediaFactory.create()
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=perk.factory.js.map